// Shared Bootstrap stylesheet for Shadow DOM components
// Uses Constructable Stylesheets for efficiency

/** @type {CSSStyleSheet|null} */
let bootstrapSheet = null;
/** @type {CSSStyleSheet|null} */
let bootstrapIconsSheet = null;
let bootstrapLoaded = false;
const loadingPromise = loadBootstrap();

async function loadBootstrap() {
    const [bootstrapResponse, iconsResponse] = await Promise.all([
        fetch('https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css'),
        fetch('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css'),
    ]);

    const [bootstrapCss, iconsCss] = await Promise.all([
        bootstrapResponse.text(),
        iconsResponse.text(),
    ]);

    bootstrapSheet = new CSSStyleSheet();
    bootstrapSheet.replaceSync(bootstrapCss);

    bootstrapIconsSheet = new CSSStyleSheet();
    bootstrapIconsSheet.replaceSync(iconsCss);

    bootstrapLoaded = true;

    return [bootstrapSheet, bootstrapIconsSheet];
}

/**
 * Get Bootstrap stylesheet (waits for load if needed)
 * @returns {Promise<CSSStyleSheet>}
 */
export async function getBootstrapStyles() {
    if (bootstrapLoaded) {
        return /** @type {CSSStyleSheet} */ (bootstrapSheet);
    }
    const [sheet] = await loadingPromise;
    return /** @type {CSSStyleSheet} */ (sheet);
}

/**
 * Get Bootstrap Icons stylesheet (waits for load if needed)
 * @returns {Promise<CSSStyleSheet>}
 */
export async function getBootstrapIconsStyles() {
    if (bootstrapLoaded) {
        return /** @type {CSSStyleSheet} */ (bootstrapIconsSheet);
    }
    const [, iconsSheet] = await loadingPromise;
    return /** @type {CSSStyleSheet} */ (iconsSheet);
}
